const generateAreaPercentageKey = (area) => `${area}_AreaDistribution`;

export default generateAreaPercentageKey;
